"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widely = void 0;
exports.widely = {
    chrome: '114',
    edge: '114',
    firefox: '114',
    safari: '16.4',
    ios: '16.4',
};
exports.default = Object.entries(exports.widely).map(([b, v]) => `${b} >= ${v}`);
//# sourceMappingURL=widely.js.map